export default {
    wizardType: "BAMBOOHR",

    getConnectionParams: (type, model) => ({
        APIKey: model.get("apiKey"),
        Domain: model.get("domain"),
    }),
};

